import React, { useEffect, useState } from "react";
import { SyncOutlined, CheckCircleOutlined, CloseCircleOutlined, ExclamationOutlined } from '@ant-design/icons';
import { useParams, Link } from "react-router-dom";
import { toast } from "react-toastify";
import { ACCOUNTURL } from "../../../components/pages/config/config";
import '../../../styles/Tsapprovel.css'

const Tsrapproval = () => {
  const { token } = useParams();
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState(false);
  const [error, setError] = useState(false);
  const [nodata, setNodata] = useState(false);
  const [sdata, setSdata] = useState('');

  useEffect(() => {
    const verify = async () => {
      setLoading(true);
      try {
        let datastring = { id: token };
        let api = `${ACCOUNTURL}tsrapproval`;
        let postData = {
          method: 'POST',
          headers: { 'content-type': 'application/json' },
          body: JSON.stringify(datastring),
        };

        let response = await fetch(api, postData);
        let res = await response.json();

        if (res.actionMsg === 1) {
          setMessage(true);
          setError(false);
        } else if (res.actionMsg === 0 && res.Message === 'No_Data') {
          setSdata('nodata');
          setNodata(true);
          setMessage(false);
          setError(false);
        } else if (res.actionMsg === 0 && res.Message === 'Already_Data') {
          setSdata('Alreadydata');
          setNodata(true);
          setMessage(false);
          setError(false);
        } else {
          setMessage(false);
          setError(true);
        }
      } catch (err) {
        let errorMessage = err.message || 'Contact Admin';
        toast.error(errorMessage, { duration: 2000 });
        setError(true);
      } finally {
        setLoading(false);
      }
    };

    const timeoutId = setTimeout(() => {
      verify();
    }, 1000);

    return () => {
      setLoading(true);
      clearTimeout(timeoutId);
    };
  }, [token]);

  return (
    <div className="tsapproval-container">
      <div className="app-logo">
      <img className="logo" src="https://www.ampstek.com/assets/img/logo6.png" alt="SRSINFOWAY Logo" />
      </div>
      <title>Timesheet Approval</title>

      {nodata && (
        <div className="status-card">
          <div className="status-icon">
            <ExclamationOutlined style={{ color: 'red', fontSize: '48px' }} />
          </div>
          <div className="status-content">
            <h3 className="status-title">
              {sdata === 'nodata' ? 'No Data Found' : 'Already Timesheet is Approved'}
            </h3>
            <p className="status-message">
              {sdata === 'nodata'
                ? 'There no data. Please send the queries to email: info@ampstek.com'
                : 'Please send any queries to email: info@ampstek.com'}
              <br />
              <Link to="/" className="home-link">Return to Home</Link>
            </p>
          </div>
        </div>
      )}

      {loading && (
        <div className="status-card">
          <div className="status-icon">
            <SyncOutlined spin style={{ color: 'orange', fontSize: '48px' }} />
          </div>
          <div className="status-content">
            <h3 className="status-title">Please Wait</h3>
            <p className="status-message">
              Timesheet is being verified and creation of access...
            </p>
          </div>
        </div>
      )}

      {error && (
        <div className="status-card">
          <div className="status-icon">
            <CloseCircleOutlined style={{ color: '#f30', fontSize: '48px' }} />
          </div>
          <div className="status-content">
            <h3 className="status-title">Error!</h3>
            <p className="status-message">
              Please contact admin. Send the queries to email: info@srsinfoway.com
              <br />
              <Link to="/" className="home-link">Return to Home</Link>
            </p>
          </div>
        </div>
      )}

      {message && (
        <div className="status-card">
          <div className="status-icon">
            <CheckCircleOutlined style={{ color: 'green', fontSize: '48px' }} />
          </div>
          <div className="status-content">
            <h3 className="status-title">Timesheet Approved Successfully</h3>
            <p className="status-message">
              Great! Experience our new Timesheet Panel
              <br />
              <Link to="/" className="home-link">Return to Home</Link>
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default Tsrapproval;